<template>
	<div id="app">
		<transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>

	</div>
</template>

<script>
export default {
	name: 'app',
	components: {
	}
}

</script>

<style lang="scss">

body {
	margin: 0px;
	padding: 0px;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
	// filter: grayscale(100%);
	// -webkit-filter: grayscale(100%);
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 20px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 20px;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	// border:1px solid #dfe6ec;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
.el-table--mini td, .el-table--mini th{
	padding: 3px 0!important;
}
.el-table th.el-table__cell{
	background-color: #f8f8f9 !important;
}

body .el-table th.gutter{
    display: table-cell!important;
}

.toolbar{
	background: #f8f8f9;
}

.el-table .el-button--text{
	border: none;
	background: transparent !important ;
}
.el-table .el-button--text:hover,.el-button--text:hover{
	border: none;
	background: transparent !important ;
	color:#66b1ff  !important ;
}
</style>


// WEBPACK FOOTER //
// App.vue?261e40a6